(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-variant-picker"] && !Shopify.designMode) return;
  try {
    document.addEventListener("DOMContentLoaded", (event) => {
  const dummyVariantPickerButton = document.querySelector(".js-open-variant-picker");
  if (!dummyVariantPickerButton) return;
  const variantPickerButton = document.querySelector("[data-modal-target='#variant-picker']");

  dummyVariantPickerButton.addEventListener("click", () => {
    variantPickerButton.click();
  });
});
  } catch(e) { console.error(e); }
})();

})();
